import React from 'react'
import styled from 'styled-components'
import { HiStar } from 'react-icons/hi'
import { appEnvironment } from 'configs'

function CategoryModal({
  active,
  setActive,
  setCategoryOpen,
  categoryOpen,
  mobile,
  mobileSelect,
  setMobileSelect,
}) {
  return (
    <Container id="category-modal" mobile={mobile}>
      <Col>
        <Label mobile={mobile}>CONSUMER</Label>
        <H1
          active={mobile ? !!(mobileSelect === '6' || mobileSelect === 6) : !!(active === '6')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('6')
                }
              : () => {
                  if (active !== '6') {
                    setActive('6')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Wedding & Engagement
        </H1>
        <H1
          id="category-family"
          active={mobile ? !!(mobileSelect === '4' || mobileSelect === 4) : !!(active === '4')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('4')
                }
              : () => {
                  if (active !== '4') {
                    setActive('4')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Family
        </H1>
        <H1
          active={mobile ? !!(mobileSelect === '5' || mobileSelect === 5) : !!(active === '5')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('5')
                }
              : () => {
                  if (active !== '5') {
                    setActive('5')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Newborn & Maternity
        </H1>
        <H1
          active={mobile ? !!(mobileSelect === '7' || mobileSelect === 7) : !!(active === '7')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('7')
                }
              : () => {
                  if (active !== '7') {
                    setActive('7')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Portrait
        </H1>
        <H1
          active={
            mobile
              ? !!(
                  mobileSelect === '12' ||
                  mobileSelect === '13' ||
                  mobileSelect === 12 ||
                  mobileSelect === 13
                )
              : !!(active === '12' || active === '13')
          }
          onClick={
            mobile
              ? () => {
                  appEnvironment === 'production' ? setMobileSelect('13') : setMobileSelect('12')
                }
              : () => {
                  if (!(active === '12' || active === '13')) {
                    appEnvironment === 'production' ? setActive('13') : setActive('12')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Events
        </H1>
        <H1
          active={mobile ? !!(mobileSelect === '9' || mobileSelect === 9) : !!(active === '9')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('9')
                }
              : () => {
                  if (active !== '9') {
                    setActive('9')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Boudoir
        </H1>
      </Col>
      <Col>
        <Label mobile={mobile}>COMMERCIAL</Label>
        <H1
          active={mobile ? !!(mobileSelect === '3' || mobileSelect === 3) : !!(active === '3')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('3')
                }
              : () => {
                  if (active !== '3') {
                    setActive('3')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Headshots
        </H1>
        <H1
          active={mobile ? !!(mobileSelect === '8' || mobileSelect === 8) : !!(active === '8')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('8')
                }
              : () => {
                  if (active !== '8') {
                    setActive('8')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Corporate Events
        </H1>
        <H1
          active={mobile ? !!(mobileSelect === '14' || mobileSelect === 14) : !!(active === '14')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('14')
                }
              : () => {
                  if (active !== '14') {
                    setActive('14')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Branding
        </H1>
        <H1
          active={mobile ? !!(mobileSelect === '10' || mobileSelect === 10) : !!(active === '10')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('10')
                }
              : () => {
                  if (active !== '10') {
                    setActive('10')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Product
        </H1>
        <H1
          active={mobile ? !!(mobileSelect === '11' || mobileSelect === 11) : !!(active === '11')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('11')
                }
              : () => {
                  if (active !== '11') {
                    setActive('11')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Architecture & Real Estate
        </H1>
        <H1
          active={mobile ? !!(mobileSelect === '2' || mobileSelect === 2) : !!(active === '2')}
          onClick={
            mobile
              ? () => {
                  setMobileSelect('2')
                }
              : () => {
                  if (active !== '2') {
                    setActive('2')
                    if (categoryOpen && mobile === false) {
                      setCategoryOpen(false)
                    }
                  }
                }
          }
        >
          Featured <StarIcon />
        </H1>
      </Col>
      <Col1>
        <CloseButton
          onClick={() => {
            if (categoryOpen && mobile === false) {
              setCategoryOpen(false)
            }
          }}
        >
          <CloseSpan1 />
          <CloseSpan2 />
        </CloseButton>
      </Col1>
    </Container>
  )
}

export default CategoryModal

const Container = styled.div`
  position: ${(props) => (props.mobile ? 'static' : 'absolute')};
  top: 60px;
  left: 100px;
  display: flex;
  z-index: 999;
  flex-wrap: wrap;
  padding: ${(props) => (props.mobile ? '0 1rem 1rem 1rem ' : '0.5rem')};
  background: #fff;
  border-radius: ${(props) => (props.mobile ? 'none' : '0.5rem')};
  box-shadow: ${(props) => (props.mobile ? 'none' : 'rgba(0, 0, 0, 0.2) 0px 6px 20px')};
  @media (max-width: 430px) {
    width: 95%;
  }
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: 1px;
  padding: 0;
  flex: 0 0 50%;
  max-width: 50%;
  font-size: 14px;
  @media (max-width: 900px) {
    flex: 0 0 45%;
  }
  @media (max-width: 700px) {
    flex: 0 0 50%;
  }
`

const Col1 = styled(Col)`
  display: none;
  @media (max-width: 900px) {
    display: block;
    flex: 0 0 4%;
  }
  @media (max-width: 700px) {
    display: none;
  }
`

const Label = styled.label`
  display: ${(props) => (props.mobile ? 'none' : 'block')};
  color: var(--forward);
  font-weight: 600;
  padding: 0.5rem 0.5rem;
`

const H1 = styled.h6`
  display: flex;
  color: ${(props) => (props.active ? 'var(--forward)' : 'var(--black)')};
  font-weight: 500;
  padding: 1rem 0.5rem;
  cursor: pointer;
  align-items: center;
  &:hover {
    color: var(--forward);
  }
  @media (max-width: 700px) {
    font-weight: 500;
  }
`

const StarIcon = styled(HiStar)`
  font-size: 1rem;
  margin: 0 0 0 0.5rem;
  color: var(--forward);
`
const CloseButton = styled.button`
  font-size: 1.25rem;
  background-color: initial;
  border: 1px solid transparent;
  color: rgba(0, 0, 0, 0.6);
  border-color: transparent;
  flex: 0 0 50%;
  max-width: 50%;
  text-align: right;
  overflow: visible;
  @media (max-width: 991.98px) {
    display: none;
  }
`
const CloseSpan1 = styled.span`
  display: block;
  position: absolute;
  width: 16px;
  height: 2px;
  border-radius: 2px;
  opacity: 1;
  background: #283448;
  transform: rotate(135deg);
  right: 7%;
`

const CloseSpan2 = styled(CloseSpan1)`
  transform: rotate(-135deg);
`
